import loadScript from '@/utils/loadScript'

export default function (dom, opts) {
  let options = {
    mapSel: '#map',
    locations: [],


    ...opts
  };


  async function init() {
    await loadScript(`https://maps.googleapis.com/maps/api/js?key=${options.apiKey}`);
    // Initiate Map
    let map = new google.maps.Map(
      dom.querySelector(options.mapSel),
      {
        zoom: 8,
        center: {lat: 46.801111, lng: 8.226667},
      }
    );


    let openInfoWindow;
    let filterValue = "";

    options.locations.forEach((location, key) => {
      const locationMarker = {
        url: 'files/dieci2/icons/location_w_logo.svg',
        scaledSize: new google.maps.Size(20, 35),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(10, 30)
      };

      let addIcons = {
        location: 'files/dieci2/icons/location.svg',
        phone: 'files/dieci2/icons/phone.svg',
        clock: 'files/dieci2/icons/lieferzeit.svg',
      };

      // Info Window Content
      let storeInfo =
        `<div class="courier-info" data-values="${location.store_name}">
            <h6 class="courier-info__name">${location.store_name}</h6>
            <div class="courier-info__content">
            <p class="courier-info__w-icon"><img src="${addIcons.location}">${location.address.address_street} ${location.address.address_streetnumber} <br>${location.address.address_zip} ${location.address.address_city}</p>
           <p class="courier-info__w-icon courier-info__w-icon--center"><img src="${addIcons.phone}" ><a href="tel:${location.communication_phonenumber}" class="courier-info__phone">${location.communication_phonenumber}</a></p>
          <div class="courier-info__time">
              <img class="courier-info__time-icon" src="${addIcons.clock}">`;
      location.openingtimes.forEach(openingTime => {
        storeInfo +=  `<div class="courier-info__time-single"><span> ${openingTime.day} </span>
                <span class="courier-info__time-hours"> ${openingTime.time}</span></div>`
      });
      storeInfo += `</div>
              <p></p>
            <p><!--<a href="${location.storeUrl_details}" class="dc-btn dc-btn--secondary dc-btn--no-arrow">${options.toDetail}</a>--></p>
            </div>
            </div>`;


      // Map Marker
      let marker = new google.maps.Marker({
        position: {lat: location.address.geocoding_lat, lng: location.address.geocoding_lng},
        map: map,
        icon: locationMarker,
        animation: google.maps.Animation.DROP,
        title: `${location.store_name}`
      });

      // Define Window Info
      let infoWindow = new google.maps.InfoWindow({
        content: storeInfo
      });

      google.maps.event.addListener(marker, 'click', () => {
        if (openInfoWindow) {
          openInfoWindow.close();
        }
        infoWindow.setContent(storeInfo);
        openInfoWindow = infoWindow;
        infoWindow.open(map, marker);
      });
    });

  }

  init()
}
